<div class="form-group">
    <div class="row fields-group">
        <div class="col-md-2 col-xs-2">
            <label class="input-label">{{ 'dets.predicate' | translate }}</label>
            <select class="form-control" [(ngModel)]="operator" (ngModelChange)="operatorValueChanged()">
                <option value="" default selected disabled>{{ 'Choose here' | translate }}</option>
                <option *ngFor="let o of operators" [ngValue]="o">{{ o | translate }}</option>
            </select>
        </div>
        <div class="col-md-10 col-xs-10" *ngIf="!isOperatorIsValid()">
            <div class="row">
                <div class="col">
                    <label class="input-label">{{ 'catalog.parent_value' | translate }}</label>
                    <search-select (change)="selectParentCatalogValueChanged($event)" [items]="parentCatalogFields"
                        [prop]="'id'" [selected]="parentCatalogFieldValueId"
                        [placeholder]="'Choose here' | translate"></search-select>
                </div>
            </div>
            <div class="row">
                <div class="col-auto"
                    *ngIf="(isCatalogMultiple || operator === SelectOperatorType.IN || operator === SelectOperatorType.NOT_IN) && !isOperatorIsValid()">
                    <label class="input-label">{{ 'dets.subject' | translate }}</label>
                    <select class="form-control" [(ngModel)]="subject" (ngModelChange)="subjectValueChanged()">
                        <option *ngFor="let s of filterSubjects(operator)" [selected]="subject == s">{{ s | translate }}
                        </option>
                    </select>
                </div>
                <div class="col">
                    <label class="input-label">{{ 'catalog.child_value' | translate }}</label>
                    <search-select
                        *ngIf="!(isCatalogMultiple || operator === SelectOperatorType.IN || operator === SelectOperatorType.NOT_IN) && subCatalogFields"
                        (change)="selectSubCatalogValueChanged($event)" [items]="subCatalogFields" [prop]="'id'"
                        [selected]="subCatalogFieldValueId" [placeholder]="'Choose here' | translate"></search-select>
                    <ng-select
                        *ngIf="(isCatalogMultiple || operator === SelectOperatorType.IN || operator === SelectOperatorType.NOT_IN) && subCatalogFields"
                        [(ngModel)]="classificationFields" bindLabel="value" bindValue="id" class="custom form-control"
                        [clearable]="true" [multiple]="true" [items]="subCatalogFields"
                        (change)="updateClassificationFields($event)"
                        placeholder="{{'Select value(s)' | translate }}"></ng-select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="input-label mt-2">{{ 'dets.comparison_field_label' | translate }}</label>
                    <search-select *ngIf="fields.length > 0" (change)="onTargetFormFieldKeyChange($event)"
                        [items]="fields" [selected]="sourceFormFieldKey"
                        [placeholder]="'Choose here' | translate"></search-select>
                </div>
            </div>
        </div>
    </div>
</div>